import Network from '@/common/lib/Network';
import Store from '@/config/store';

export default {

  getDevise() {
    return Network.execute('GET', 'CWEBS0012A', {
      piduser: Store.getters['application/get_application_user'].id,
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
    });
  },
  uploadImport(formData) {
    return Network.execute('POST', 'upload_import', {}, formData, {
      'Content-Type': 'multipart/form-data'
    });
  },
}